export default {
  initialModal: {
    title: 'Bem-vindo ao Prodgy! 🎉',
    description: 'Gostaríamos de guiá-lo através das principais funcionalidades da plataforma. Este tour levará apenas alguns minutos.',
    benefits: 'Ao completar este tour você irá:',
    benefit1: 'Criar seu primeiro workspace',
    benefit2: 'Configurar sua base de conhecimento',
    benefit3: 'Conectar integrações e instalar agentes IA',
    benefit4: 'Testar seus agentes no playground',
    start: 'Iniciar Tour',
    skip: 'Pular',
    alreadyCompleted: 'Você já completou este tour!'
  },
  completionModal: {
    title: 'Parabéns! 🎊',
    description: 'Você completou o tour guiado com sucesso!',
    message: 'Agora é com você!',
    helpText: 'Você pode reiniciar este tour a qualquer momento através do menu do usuário.',
    close: 'Continuar usando...'
  },
  closeConfirmation: {
    title: 'Deseja realmente sair do tour?',
    message: 'Você perderá o progresso atual do tour guiado. Você pode reiniciá-lo a qualquer momento através do menu de ajuda.',
    confirm: 'Sim, sair do tour',
    cancel: 'Continuar tour'
  },
  checklist: {
    title: 'Tour Guiado'
  },
  navbar: {
    restart: 'Reiniciar Tour'
  },
  reminder: {
    title: 'Estou aqui sempre que precisar!',
    message: 'Você pode retomar o tour a qualquer momento através do botão de ajuda na barra superior.'
  }
};
